module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-10.08505085.png";